import { jsx as _jsx } from "react/jsx-runtime";
import { dispatchTrackingEvent, TrackingEvents } from "@jti/tracker";
import { Accordion } from "../Accordion";
import { AccordionItem } from "../AccordionItem";
import { List } from "../List";
export const FaqCategory = ({ items, singleExpanded }) => {
    const dispatchGTMEvent = (title) => {
        dispatchTrackingEvent(TrackingEvents.TrackingFaqLink, { faq_name: title });
    };
    const accordionItems = items.reduce((acc, curr) => {
        acc.push({
            ...curr,
            content: _jsx(List, { ...curr.content }),
        });
        return acc;
    }, []);
    return (_jsx(Accordion, { singleExpanded: singleExpanded, dispatchGTMEvent: dispatchGTMEvent, children: accordionItems.map(({ id, title, content }) => (_jsx(AccordionItem, { id: id, title: title, children: content }, id))) }));
};
//# sourceMappingURL=FaqCategory.js.map